import React, { useContext } from 'react'
import { defaultState } from '../libs/fetchWebcastCommunities'
import useWebcastCommunities from '../libs/useWebcastCommunities'
import { EnvVariablesContext } from '../contexts/EnvVariablesContext'

export const WebcastCommunitiesContext = React.createContext(defaultState)

const { Provider } = WebcastCommunitiesContext

const WebcastCommunitiesProvider = ({ value, children }) => {

  const { hostUrl  } = useContext(EnvVariablesContext)
  const { data } = useWebcastCommunities(value ?? defaultState, hostUrl)

  return <Provider value={data}>{ children }</Provider>

}

export default WebcastCommunitiesProvider
